export default "/images/security-shield.png";